import type { GetReview200AllOf } from './getReview200AllOf';
import type { GetReview200AllOfTwo } from './getReview200AllOfTwo';

export type GetReview200 = GetReview200AllOf & GetReview200AllOfTwo;
